import {
  callIfFn,
  EntityPlacerBuilder,
  plannerHistoryHelper
} from "src/components/Planner/planner/history";
import { PlannerAction } from "src/components/Planner/planner/history/planner-action";
import {ts} from "src/utils/translate"
import {
  getRoomById,
  isRoomOutside,
  uDev
} from "src/components/Planner/planner/uDev";
import {PlannerGlobals} from "src/components/Planner/planner/planner-globals";
import { wallModHelperDOM } from "src/components/Planner/planner/wallModHelper-dom";

/* WINDOW/DOOR START */

export class WallModAction extends PlannerAction {
  /**
   *
   * @param {WallModConnection} wallModConn
   */
  constructor(wallModConn, matSaveState) {
    super();
    this.wallModConn = wallModConn;
    this.changesMats = uDev.outerBorderExists() && (wallModConn.rooms.some(room => !isRoomOutside(getRoomById(room.roomId), PlannerGlobals.outerBorder)));
    this.matSaveState = this.changesMats ? matSaveState : {};
  }
  restoreWallMats() {
    return new Promise((res, rej) => {
      if (this.changesMats) {
        new EntityPlacerBuilder()
        .setMatSaveState(this.matSaveState)
        .run().then(res).catch(rej);
      }
      else {
        return res();
      }
    });
  }
  resetWallMats() {
    return new Promise((res, rej) => {
      if (this.changesMats) {
        PlannerGlobals.wallSegmentation.recalcPreserveSave(this.matSaveState, true);
        new EntityPlacerBuilder()
        .setMatSaveState(PlannerGlobals.wallSegmentation.getSaveDataV2())
        .run().then(res).catch(rej);
      }
      else {
        return res();
      }
    });
  }
  /* wallModConnIdChanged(from, to) {
      if (this.equalAsString(this.wallModConn.id, from)) {
          this.wallModConn.id = to;
      }
  } */
  wallModIdChanged(from, to) {
    var thisVar = this;
    this.wallModConn.rooms.forEach(function (wm) {
      if (thisVar.equalAsString(wm.id, from)) {
        wm.id = to;
      }
    });
  }
  wallIdChanged(from, to) {
    var thisVar = this;
    this.wallModConn.rooms.forEach(function (wm) {
      wm.wallIds.forEach(function (id, idx) {
        if (thisVar.equalAsString(id, from)) {
          wm.wallIds[idx] = to;
        }
      });
    });
  }
  roomIdChanged(from, to) {
    var thisVar = this;
    this.wallModConn.rooms.forEach(function (wm) {
      if (thisVar.equalAsString(wm.roomId, from)) {
        wm.roomId = to;
      }
    });
    plannerHistoryHelper.updateMatStateRoomId(from, to, this.matSaveState);
  }
}

export class CreateWallModAction extends WallModAction {
  /**
   *
   * @param {WallModConnection} wallModConn
   */
  constructor(wallModConn, matSaveState) {
    super(wallModConn, matSaveState);
    this.actionName = this.wallModConn.type == "door" ?
        ts("p_do_action_door_new", "Creating door") :
        ts("p_do_action_win_new", "Creating window");
  }
  execute(callback) {
    const thisVar = this;
    this.wallModConn.isAJAXWait = true;
    PlannerGlobals.wallModConnections.push(this.wallModConn);
    wallModHelperDOM.redrawWallMods();
    var preId = this.wallModConn.id;
    var preIds = this.wallModConn.rooms.map(function (wallMod) { return wallMod.id; });
    wallModHelperDOM.sendWallMod(this.wallModConn, function (newWallModConn) {
      PlannerGlobals.plannerHistoryManager.wallModConnIdChanged(preId, newWallModConn.id);
      var postIds = newWallModConn.rooms.map(function (wallMod) { return wallMod.id; });
      for (var i = 0; i < postIds.length; i++) {
        PlannerGlobals.plannerHistoryManager.wallModIdChanged(preIds[i], postIds[i]);
      }
      thisVar.resetWallMats().then(() => callIfFn(callback, true)).catch(() => callIfFn(callback, false));
    }, function () {
      callIfFn(callback, false);
    });
  }
  undo(callback) {
    const thisVar = this;
    wallModHelperDOM.removeWallModConn(this.wallModConn.id, function () {
      thisVar.restoreWallMats().then(() => callIfFn(callback, true)).catch(() => callIfFn(callback, false));
    }, function () {
      callIfFn(callback, false);
    });
  }
}
export class DeleteWallModAction extends WallModAction {
  /**
   *
   * @param {WallModConnection} wallModConn
   * @param {MeasurementConnection[]} measures
   */
  constructor(wallModConn, measures, matSaveState) {
    super(wallModConn, matSaveState);
    this.actionName = this.wallModConn.type == "door" ?
        ts("p_do_action_door_del", "Deleting door") :
        ts("p_do_action_win_del", "Deleting window");
    this.measures = measures;
  }
  execute(callback) {
    const thisVar = this;
    wallModHelperDOM.removeWallModConn(this.wallModConn.id, function () {
      //callIfFn(callback, true);
      thisVar.resetWallMats().then(() => callIfFn(callback, true)).catch(() => callIfFn(callback, false));
    }, function () {
      callIfFn(callback, false);
    });
  }
  undo(callback) {
    var thisVar = this;
    this.wallModConn.isAJAXWait = true;
    PlannerGlobals.wallModConnections.push(this.wallModConn);
    wallModHelperDOM.redrawWallMods();
    var preId = this.wallModConn.id;
    var preIds = this.wallModConn.rooms.map(function (wallMod) { return wallMod.id; });
    wallModHelperDOM.sendWallMod(this.wallModConn, function (newWallModConn) {
      PlannerGlobals.plannerHistoryManager.wallModConnIdChanged(preId, newWallModConn.id);
      var postIds = newWallModConn.rooms.map(function (wallMod) { return wallMod.id; });
      for (var i = 0; i < postIds.length; i++) {
        PlannerGlobals.plannerHistoryManager.wallModIdChanged(preIds[i], postIds[i]);
      }
      plannerHistoryHelper.putBackMeasurementConns(thisVar.measures)
      .done(function () {
        /* callIfFn(callback, true); */
        thisVar.restoreWallMats().then(() => callIfFn(callback, true)).catch(() => callIfFn(callback, false));
      })
      .fail(function () {
        callIfFn(callback, false);
      });
    }, function () {
      callIfFn(callback, false);
    });
  }
  deviceIdChanged(from, to) {
    plannerHistoryHelper.updateMeasurementDeviceIds(from, to, this.measures);
  }
  serialIdChanged(from, to) {
    plannerHistoryHelper.updateMeasurementSerialIds(from, to, this.measures);
  }
  wallModIdChanged(from, to) {
    plannerHistoryHelper.updateMeasurementWallModIds(from, to, this.measures);
  }
}
/* WINDOW/DOOR END */
